







import Vue from 'vue'
import SubscriptionForm from './components/SubscriptionForm.vue';
import UnsubscribeForm from './components/UnsubscribeForm.vue';
import { IState } from './store/state';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {

}

interface AppComputed {
	showForm: boolean;
}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		showForm() {
			return (this.$store.state as IState).route === '/';
		}
	},
	components: {
		SubscriptionForm,
		UnsubscribeForm
	}
})
